export default {"src":"/_next/static/media/nubrakes-logo-no-text.7abecb29.svg","height":47,"width":94};